import { useState, useCallback } from 'react';

export const useStagePanelVisibility = (initialState = true) => {
  const [isVisible, setIsVisible] = useState(initialState);

  const toggleVisibility = useCallback(() => {
    setIsVisible(prev => !prev);
  }, []);

  const hide = useCallback(() => {
    setIsVisible(false);
  }, []);

  const show = useCallback(() => {
    setIsVisible(true);
  }, []);

  return {
    isVisible,
    toggleVisibility,
    hide,
    show,
  };
};

export default useStagePanelVisibility;
